/*
 * @Description: '结局方案'页面所有路由
*/

export default [
    {
        path: 'solution',
        component: resolve => require(['@/views/solution'], resolve),
        name: 'Solution',
        meta: {
            nav: '解决方案'
        }
    },
  {
    path: 'solution_detail',
    component: resolve => require(['@/views/solution/detail'], resolve),
    name: 'solution_detail',
    meta: {
      nav: '解决方案'
    }
  }

]



// WEBPACK FOOTER //
// ./src/router/solution.js